// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E3Cc","title":"styles_title__3ixWo"};